export enum CvTypeEnum {
    ORIGIN_CV = 'ORIGIN_CV',
    CONSULTANT_CV = 'CONSULTANT_CV'
}